
import Vue from "vue";
import { Component } from "vue-property-decorator";
import SingularityPanelHeader from "../PanelHeader/SingularityPanelHeader.vue";

@Component({
  components: {
    SingularityPanelHeader
  }
})
export default class SettingsPanel extends Vue {}
